import { render } from "./HeroiconsOutlineMinusCircle.vue?vue&type=template&id=359d4aec"
const script = {}

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMinusCircle.vue"]])

export default __exports__